
    import __i18nConfig from '@next-translate-root/i18n'
    import __appWithI18n from 'next-translate/appWithI18n'
    
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Script from 'next/script';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { ThemeProvider } from 'next-themes';
import { LiveChatWidget } from '@livechat/widget-react';
import { APIProvider } from '@vis.gl/react-google-maps';
import 'react-loading-skeleton/dist/skeleton.css';

import { wrapper } from '@/store/store';
import { useWindowSize } from '@/hooks/index';

import { envVariables } from '../constants';

import '@/styles/pages/index.scss';

function MyApp({ Component, pageProps }) {
  const router = useRouter();
  const [windowsX] = useWindowSize();
  const [isChatVisible, setChatVisible] = useState(false);
  const lastSizeMobile = 576;

  useEffect(() => {
    if (typeof window !== 'undefined' && router.query.chat === 'maximized') {
      const { pathname, query } = router;
      const errorTimeout = setTimeout(() => {
        delete query.chat;
        router.replace({ pathname, query });
      }, 900000);

      return () => {
        clearTimeout(errorTimeout);
      };
    }
  }, [router]);

  useEffect(() => {
    if (router.query.chat || windowsX < lastSizeMobile) {
      setChatVisible(true);
    } else {
      setChatVisible(false);
    }
  }, [router.query.chat, windowsX]);

  // Reload bot script when chat visibility changes
  const loadBotScript = () => {
    const scriptElement = document.createElement('script');
    scriptElement.src =
      'https://bot.emplifi.io/components/Launchers/Messenger/LauncherSelector.js';
    scriptElement.type = 'text/javascript';
    scriptElement.async = true;
    document.body.appendChild(scriptElement);
  };

  // Trigger bot script when the chat is not visible and the window is large enough
  useEffect(() => {
    if (!router.query.chat && windowsX >= lastSizeMobile) {
      loadBotScript();
    }
  }, [router.query.chat, windowsX]);

  return (
    <APIProvider apiKey={envVariables.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY}>
      <ThemeProvider enableSystem={false}>
        <Script
          strategy='afterInteractive'
          id='astuteBotMessengerSettingsScript'
          dangerouslySetInnerHTML={{
            __html: `window.astuteBotMessengerSettings = {
      channelId: "pSJMombz-ZrnOJ71_5dJNA"
  };`,
          }}
        />
        {isChatVisible && (
          <LiveChatWidget
            license='12830742'
            visibility={router?.query?.chat || 'minimized'}
          />
        )}
        <Component {...pageProps} />
      </ThemeProvider>
    </APIProvider>
  );
}

const __Page_Next_Translate__ = wrapper.withRedux(MyApp);


    export default __appWithI18n(__Page_Next_Translate__, {
      ...__i18nConfig,
      isLoader: true,
      skipInitialProps: false,
      loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
    });
  